import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AUTHENTICATION_FEATURE_KEY, State } from './authentication.reducer';

export const getAuthenticationState = createFeatureSelector<State>(AUTHENTICATION_FEATURE_KEY);

export const getHasAccessToken = createSelector(getAuthenticationState, (state) => {
  return state.hasAccessToken;
});

export const getExpirationDate = createSelector(getAuthenticationState, (state) => {
  return state.expirationDate;
});

export const authenticationQuery = {
  getAuthenticationState,
  getHasAccessToken,
  getExpirationDate,
};
